import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Storage, ref, uploadBytes, getDownloadURL } from '@angular/fire/storage';
import { GeneralService } from 'src/services/general.service';

/* 🔹 Interfaces (CLAVE) */
interface Clima {
  ID: string;
  URL: string;
  TEXTO: string;
}

interface Noticia {
  ID: string;
  ENLACE: string;
  ENCABEZADO: string;
  FECHA: string;
}

interface Banner {
  URL: string;
}

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  /* 🔹 DATA */
  clima: Clima[] = [];
  data: Noticia[] = [];
  bann: Banner[] = [];

  /* 🔹 UI */
  token = false;
  boton = 0;
  activeMap: 'mexico' | 'region' = 'mexico';

  /* 🔹 LOADING */
  subiendo = {
    mexico: false,
    region: false,
    autlan: false
  };

  /* 🔹 FORMS */
  mexicoForm!: FormGroup;
  regionalForm!: FormGroup;
  autlanForm!: FormGroup;

  constructor(
    private router: Router,
    private service: GeneralService,
    private storage: Storage,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {

    /* 🔐 TOKEN */
    this.token = !!localStorage.getItem('token');
    this.boton = this.token ? 1 : 0;

    /* 📡 DATA */
    this.loadData();

    /* 🧾 FORMS */
    this.initForms();
  }




  initForms() {
    this.mexicoForm = this.fb.group({
      ID: ['1'],
      URL: ['', Validators.required]
    });

    this.regionalForm = this.fb.group({
      ID: ['2'],
      URL: ['', Validators.required]
    });

    this.autlanForm = this.fb.group({
      ID: ['3'],
      URL: ['', Validators.required]
    });
  }

  loadData() {
    this.service.verClima().subscribe(res => {
      this.clima = res.body || [];
    });

    this.service.verNoticias().subscribe(res => {
      this.data = res.body || [];
    });

    this.service.verBanner().subscribe(res => {
      this.bann = res.body || [];
    });
  }

  /* =========================
     🔹 UI CONTROL
  ========================== */


  /* =========================
     🔹 GUARDAR CLIMA
  ========================== */

  guardar(tipo: 'mexico' | 'region' | 'autlan') {

    const formMap = {
      mexico: this.mexicoForm,
      region: this.regionalForm,
      autlan: this.autlanForm
    };

    const form = formMap[tipo];

    if (form.invalid) return;

    this.service.editarClima(form.value).subscribe(() => {
      this.loadData();
      this.subiendo[tipo] = false;
    });
  }

  /* =========================
     🔹 SUBIR ARCHIVO (UNIFICADO)
  ========================== */

  async subirArchivo(event: any, tipo: 'mexico' | 'region' | 'autlan') {

    const file = event.target.files[0];
    if (!file) return;

    this.subiendo[tipo] = true;

    this.service.obtenerIdentificadorDocumentos(1).subscribe(async res => {

      const identificador = res.body;
      const path = `Noticias/${identificador}-Autlan`;

      const fileRef = ref(this.storage, path);

      await uploadBytes(fileRef, file);

      const url = await getDownloadURL(fileRef);

      /* 🔥 asignar al form correcto */
      if (tipo === 'mexico') this.mexicoForm.patchValue({ URL: url });
      if (tipo === 'region') this.regionalForm.patchValue({ URL: url });
      if (tipo === 'autlan') this.autlanForm.patchValue({ URL: url });

      this.subiendo[tipo] = false;
    });
  }

  /* =========================
     🔹 NAV
  ========================== */


toggle(tipo: 'mexico' | 'region') {
  this.activeMap = tipo;
}




  editar() {
    this.router.navigate(['admin/editar-banner']);
  }

  subirNoticia() {
    this.router.navigate(['admin/subir-noticia']);
  }

}
